export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Licensing & Credentials',
      items: [
        'Valid contractor license',
        'Current liability insurance',
        'Workers compensation coverage',
        'BBB accreditation and rating',
        'Industry certifications (NTCA, etc.)'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Years installing tile in El Paso',
        'Experience with your tile type',
        'Portfolio of completed projects',
        'Specialty in residential/commercial',
        'Knowledge of local building codes'
      ]
    },
    {
      category: 'Pricing & Estimates',
      items: [
        'Free written estimates',
        'Detailed material and labor costs',
        'Transparent pricing structure',
        'Payment schedule and terms',
        'Warranty on installation'
      ]
    },
    {
      category: 'Reputation & Reviews',
      items: [
        'Online reviews and ratings',
        'Local references available',
        'Before and after photos',
        'Response time to inquiries',
        'Customer service quality'
      ]
    }
  ];

  return (
    <section id="checklist" className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tile Installer Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Use this comprehensive checklist to evaluate and compare tile installers in El Paso. Make an informed decision for your tile project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div key={index} className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-teal-500 transition-all">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className="ri-checkbox-circle-line text-2xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{section.category}</h3>
              </div>
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-teal-600 rounded-xl p-8 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl font-bold mb-4">Red Flags to Watch For</h3>
            <div className="grid md:grid-cols-3 gap-6 text-left">
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-2xl flex-shrink-0"></i>
                <div>
                  <strong className="block mb-1">No License</strong>
                  <p className="text-sm text-white/90">Always verify valid contractor license</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-2xl flex-shrink-0"></i>
                <div>
                  <strong className="block mb-1">Unusually Low Bid</strong>
                  <p className="text-sm text-white/90">May indicate poor quality or hidden costs</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-2xl flex-shrink-0"></i>
                <div>
                  <strong className="block mb-1">No Portfolio</strong>
                  <p className="text-sm text-white/90">Reputable installers show completed work</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
